import { cn } from '@/utils/cn'

interface TeamMember {
  role: string
  firstName: string
  lastName: string
  email: string | null
  linkedInProfileUrl: string | null
  teamMemberImageUrl?: string | null
  theme: any
}

export const TeamMemberItem = (props: TeamMember) => {
  const { role, firstName, lastName, email, linkedInProfileUrl, teamMemberImageUrl, theme } = props
  // console.log(props)
  return (
    <div
      className="flex items-center gap-4 "
      // className='flex gap-4 mr-6 last:mr-0'
      style={{ flex: '0 0 auto' }}
    >
      <div className="size-[170px] overflow-hidden rounded-full xl:size-[180px]">
        {teamMemberImageUrl ? (
          <img
            src={teamMemberImageUrl}
            alt={firstName}
            className="h-full  w-full object-cover"
          />
        ) : (
          <img
            src="/images/preview/user-dummy.png"
            alt={firstName}
            className="h-full w-full object-cover"
          />
        )}
      </div>
      <div
        className={cn(
          // 'w-[151px]  overflow-hidden lg:w-[180px]',
          // 'min-w-[150px] max-w-[151px]  overflow-hidden lg:min-w-[179px] lg:max-w-[180px]',
          'flex w-[151px]  md:w-[154px] flex-col justify-center overflow-hidden  lg:w-[180px]',
          // 'flex min-w-[150px] max-w-[151px] md:min-w-[153px] md:max-w-[154px] flex-col justify-center overflow-hidden lg:min-w-[179px] lg:max-w-[180px]',
        )}
        // className={cn('flex min-w-[154px] flex-col justify-center  lg:min-w-[179px] lg:max-w-[180px]')}
        // className={cn('flex min-w-[154px] max-w-[160px] flex-col justify-center  lg:min-w-[180px]')}
        // className={cn('flex w-[154px] flex-col justify-center  lg:w-[180px]')}
        style={{
          color: theme.primaryFontColor,
          fontFamily: theme.fontFamilyPrimary,
        }}
      >
        <h3 className="mb-2 font-medium leading-[110%] xl:text-[18px] xl:leading-[100%]">
          {firstName} {lastName}
        </h3>
        <p className="text-sm font-light leading-[125%] xl:text-base ">{role}</p>
        {email && (
          <p className="mt-3 max-w-[160px]  break-all text-sm font-light leading-[125%] xl:text-base">{email}</p>
        )}

        {linkedInProfileUrl && (
          <a
            href={linkedInProfileUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 w-fit rounded-full border px-4 py-3 text-sm leading-[120%] lg:text-base lg:leading-[125%]"
            style={{
              color: theme.primaryFontColor,
              border: `1px solid ${theme.primaryFontColor}`,
              fontFamily: theme.fontFamilyPrimary,
            }}
          >
            LinkedIn
          </a>
        )}
      </div>
    </div>
  )
}
